import { jsx as _jsx } from "react/jsx-runtime";
import QueryInput from "./query-input";
const classes = {
    groupClassName: "ms3-query-input-with-label",
    labelClassName: "ms3-query-input-with-label__label",
    inputContainerClassName: "ms3-query-input-with-label__input-container",
    className: "ms3-query-input-with-label__input",
    resetButtonClassName: "ms3-query-input-with-label__reset-button",
};
function QueryInputWithLabel(props) {
    return _jsx(QueryInput, Object.assign({}, classes, props));
}
export default QueryInputWithLabel;
